import React, { useContext, useEffect, useState } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { createConfig } from "../../redux/utils";
//import { getCurrentUrl } from "../../_metronic/layout/components/aside/aside-menu/AsideMenuCustomList";
import { getCurrentUrl, toAbsoluteRouterUrl } from "../../_metronic/_helpers";
import { MenuSSO } from "../services/ApiService";
import { useAuthContext } from "./Auth";
import { useSnackContext } from "./Snack";
/*
const menuInit = {
  homeUrl: "/",
  brandImg: "",
  loginImg: "",
  sectionRoot: {
    caption: "",
    features: [
      {name: "", caption: "", url: "", hasSubmenu: false, icon: ""},
    ]
  },
  sections: [
    { 
      caption: "", 
      features: [
        {
          caption: "", 
          icon: "",
          features: [
            {name: "", caption: "",  url: "", exact: false, icon: ""}
          ]       
        },
      ]
    }
  ]
}
*/
export const useFeatureAccess = ({setMessagesUrl, setMessagesTarget}) => {
  const [menu, setMenu] = useState({});
  const [config, setConfig] = useState({controllers:[]});
  const [loaded, setLoaded] = useState(false);
  const {openAxiosError} = useSnackContext();

  useEffect(()=>{
    const newMenu = createConfig({menu});
    console.log(newMenu)
    setConfig(newMenu);
  }, [menu])
  
   useEffect(()=>{
    if(!menu?.messagesUrl || !menu?.messagesTarget) return;
    setMessagesUrl(menu.messagesUrl);
    setMessagesTarget(menu.messagesTarget);
  }, [menu?.messagesUrl, menu?.messagesTarget]) 
  
  useEffect(()=>{
    setLoaded(true);
  }, [config])

  const load = (token) => {
    MenuSSO(token)
    .then(response => {
      setMenu(response.data);
    }).catch(error => {
      openAxiosError(error);
    });
  }

  return { config, menu, loaded, load };
}

export const FeatureAccessContext = React.createContext(useFeatureAccess); 

export const useFeatureAccessContext = () => { 
  return useContext(FeatureAccessContext); 
};

export const FeatureAccessProvider = ({ children }) => {

  const {auth, setMessagesUrl, setMessagesTarget} = useAuthContext();
  const featureAccess = useFeatureAccess({setMessagesUrl, setMessagesTarget});


  useEffect(()=>{
    featureAccess.load(auth.token);
  },[auth.token])

  return (
    <>
    <FeatureAccessContext.Provider value={featureAccess}>
      {children}
    </FeatureAccessContext.Provider>
    </>
  );
};


export const RedirectToHome = () => {
  const {menu, loaded} = useFeatureAccessContext();
  const location = useLocation();

  return (
    <>
      { loaded && menu.homeUrl && !getCurrentUrl(location) &&
        <Redirect to={toAbsoluteRouterUrl(menu.homeUrl)}/>
      }
    </>
  )
}